import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { AuthGuard } from "@/components/AuthGuard";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MockBanner } from "@/components/MockBanner";
import { isMockMode } from "@/lib/extract";
import { trackPageView } from "@/lib/gtag";
import { LoginPage } from "@/pages/LoginPage";
import { UploadPage } from "@/pages/UploadPage";
import { PricingPage } from "@/pages/PricingPage";
import { ApiPage } from "@/pages/ApiPage";
import { BillingPage } from "@/pages/BillingPage";
import { AuthCallbackPage } from "@/pages/AuthCallbackPage";
import { PrivacyPage, TermsPage } from "@/pages/LegalPages";
import { SupportPage } from "@/pages/SupportPage";
import { AdminUsersPage } from "@/pages/AdminUsersPage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RouteAnalytics />
        <div className="min-h-screen flex flex-col">
          {isMockMode() && <MockBanner />}
          <Header />
          <main className="flex-1">
            <Routes>
              {/* Tool-as-landing-page: the dropzone IS the homepage */}
              <Route path="/" element={<UploadPage />} />
              {/* /upload is kept as an alias so existing links and post-login intents keep working */}
              <Route path="/upload" element={<Navigate to="/" replace />} />

              <Route path="/login" element={<LoginPage />} />
              <Route path="/auth/callback" element={<AuthCallbackPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/api" element={<ApiPage />} />
              <Route
                path="/billing"
                element={
                  <AuthGuard>
                    <BillingPage />
                  </AuthGuard>
                }
              />
              <Route path="/legal/privacy" element={<PrivacyPage />} />
              <Route path="/legal/terms" element={<TermsPage />} />
              <Route path="/support" element={<SupportPage />} />
              <Route
                path="/admin/users"
                element={
                  <AuthGuard>
                    <AdminUsersPage />
                  </AuthGuard>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

/**
 * Fires a gtag page_view on every SPA route change. Mounted inside the
 * BrowserRouter so useLocation() works.
 */
function RouteAnalytics() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}
